<template>
  <uni-popup ref="inquiry" type="bottom" @change="changePopup">
    <uni-card :is-full="true" title="问诊详情">
      <uni-list>
        <uni-list-item>
          <template v-slot:header>
            <div class="imgFa">
              <img
                class="img"
                :src="
                  require('@funcPuzzle/mini_doctor/' +
                    [inquiryDetail.patientSex === '2' ? 'woman' : 'man'] +
                    '.png')
                "
              />
            </div>
          </template>
          <template v-slot:title>
            <div class="patientName">
              <span>{{ inquiryDetail.patientName }}</span>
            </div>
          </template>
          <template v-slot:note>
            <div>
              <span class="sex">
                {{ getKeyValueText('sex_code', inquiryDetail.patientSex) }}
              </span>
              <span>{{ birthToAge(inquiryDetail.patientBirth) }}</span>
            </div>
          </template>
          <template v-slot:footer>
            <div class="serviceType">
              <span>
                {{ getKeyValueText('service_way', inquiryDetail.serviceType) }}
              </span>
            </div>
          </template>
        </uni-list-item>
      </uni-list>
      <div class="block_wrap">
        <div>
          <span>预约时间</span>
          <span>
            {{ dayjs(inquiryDetail.regVisitTime).format('YYYY-MM-DD hh:mm') }}
          </span>
        </div>
        <div>
          <span>症状描述</span>
          <span>{{ inquiryDetail.symptomDesc }}</span>
        </div>
        <div v-if="treginfoPicsList[0]">
          <span>
            图片
            <span class="preview">(点击查看大图)</span>
          </span>
          <div class="img_wrap">
            <img
              v-for="(item, i) in treginfoPicsList"
              :key="i"
              :src="outImageFullPath(item.picLink)"
              class="inquiry_img"
              @click="previewImg(i)"
            />
          </div>
        </div>
      </div>

      <template v-slot:close>
        <uni-icons type="closeempty" color="#666" @click="close" />
      </template>
      <div v-if="inquiryDetail.visitState === '1'" class="footer-box" @click="acceptPatient">
        <span class="btn">确认接收订单</span>
      </div>
    </uni-card>
  </uni-popup>
</template>

<script>
import { getKeyValueText, birthToAge, outImageFullPath } from '@/views/funcPuzzle/utils/util.js'
import { mapState } from 'vuex'
import { getVisitRecordOnlineDetail, acceptedPatientVisit } from '@/views/funcPuzzle/utils/index.js'
import dayjs from 'dayjs'
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    value: {
      type: [Object, String],
      default: ''
    },
    inquiryDetail: {
      type: [Object, String],
      default: ''
    },
    dataBox: {
      type: [Object, String],
      default: ''
    }
  },
  data() {
    return {
      list: [],
      treginfoPicsList: [],
      visitState: '',
      birthToAge,
      repeatClick: false //重复点击状态
    }
  },
  methods: {
    dayjs,
    getKeyValueText,
    outImageFullPath,
    reception() {
      if (!this.$refs.inquiry) {
        return false
      }
      this.$refs.inquiry.close()
    },
    close() {
      if (!this.$refs.inquiry) {
        return false
      }
      this.$emit('update:visible', false)
      this.$refs.inquiry.close()
    },
    changePopup(val) {
      if (!val.show) {
        this.$emit('update:visible', false)
      }
    },
    previewImg(index) {
      const imgList = this.treginfoPicsList.map(item => {
        return outImageFullPath(item.picLink)
      })
      uni.previewImage({
        current: index, // 当前显示图片的http链接
        urls: imgList // 需要预览的图片http链接列表
      })
    },
    getDetails(visitID) {
      getVisitRecordOnlineDetail({
        visitID
      }).then(rs => {
        this.$store.commit('SET_PATIENT_USERID', rs.VisitRecordOnlineDetail.userID)
        this.treginfoPicsList = rs.reginfo.treginfoPicsList
        this.visitState = rs.VisitRecordOnlineDetail.visitState
      })
    },
    acceptPatient() {
      const { repeatClick } = this
      // 防止重复点击
      if (repeatClick) {
        return
      }
      this.repeatClick = true
      acceptedPatientVisit({
        id: this.inquiryDetail.id,
        doctorID: this.doctor.doctorID
      }).then(rs => {
        if (rs.code !== 0) {
          this.repeatClick = false
          return false
        }
        this.reception()
        uni.showToast({
          title: '接收订单',
          icon: 'none'
        })
        setTimeout(() => {
          this.repeatClick = false
          uni.navigateTo({
            url: `/subpackage/pages/chat/chat?visitID=${this.dataBox.visitID}`
            // url: `/subpackage/pages/chat/chat?params=${encodeURIComponent(
            //   JSON.stringify(this.dataBox)
            // )}`
          })
        }, 1000)
      })
    }
  },
  computed: {
    ...mapState(['doctor']),
    selectValue: {
      set(val) {
        this.$emit('input', val)
      },
      get() {
        return this.value
      }
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.$refs.inquiry.open()
      } else {
        this.close()
      }
    },
    inquiryDetail(val) {
      if (val) {
        this.getDetails(val.visitID)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.drug ::v-deep .uni-card__header-title-text {
  text-align: center;
}
.drug ::v-deep .uni-list-item__extra {
  width: 2.901333rem;
  height: 0.981333rem;
  border: 0.021333rem solid #7dd5b1;
  border-radius: 0.085333rem;
}
</style>
<style lang="scss" scoped>
.serviceType {
  width: 2.901333rem;
  height: 0.981333rem;
  border: 0.021333rem solid #7dd5b1;
  border-radius: 0.085333rem;
  text-align: center;
  line-height: 0.981333rem;
  font-size: 0.597333rem;
  font-family: PingFang SC;
  font-weight: 300;
  color: #18c47c;
}
.patientName {
  font-size: 0.725333rem;
  font-family: PingFang SC;
  font-weight: bold;
  color: #222222;
}
.imgFa {
  position: relative;
  width: 2.005333rem;
  height: 2.005333rem;
  margin: 0.213333rem 0.426667rem 0 0;
  .img {
    border-radius: 0.213333rem;
    height: 2.005333rem;
    width: 2.005333rem;
  }
}
.sex {
  margin-right: 0.512rem;
}
.block_wrap {
  height: 14.933333rem;
  padding: 0.64rem;
  .img_wrap {
    width: 100%;
    display: flex;
    flex-direction: row !important;
    flex-wrap: wrap;
    .inquiry_img {
      width: 3.2rem !important;
      height: 3.2rem !important;
      margin-right: 0.469333rem !important;
      margin-bottom: 0.469333rem;
    }
  }
  view {
    display: flex;
    flex-direction: column;
    margin-bottom: 0.853333rem;
  }
  view text:first-child {
    font-size: 0.64rem;
    font-family: PingFang SC;
    font-weight: bold;
    color: #222222;
    margin-bottom: 0.512rem;
  }
  view text:last-child {
    font-size: 0.597333rem;
    font-family: PingFang SC;
    font-weight: 300;
    color: #444444;
    line-height: 0.896rem;
  }
  .preview {
    font-size: 0.512rem;
    font-family: PingFang SC;
    font-weight: 300;
    color: #888888;
  }
}
.footer-box {
  align-items: center;
  text-align: center;
  height: 100%;
  width: 14.72rem;
  margin-left: 0.64rem;
  height: 1.536rem;
  margin-bottom: 1.706667rem;
}
.btn {
  display: inline-block;
  background: #2772ff;
  width: 100%;
  line-height: 1.536rem;
  color: #fff;
  font-size: 0.554667rem;
  border-radius: 0.213333rem;
}
</style>
